import React from 'react';
import { FONTS } from '../../styles/tokens';
import type { GitHubRepo } from '../../lib/github-api';

interface Colors { text: string; textSecondary: string; card: string; border: string }

interface RepoPickerProps {
  repos: GitHubRepo[];
  value: GitHubRepo | null;
  onChange: (repo: GitHubRepo | null) => void;
  colors: Colors;
}

/** Dropdown listing repositories visible to the selected installation. */
export function RepoPicker(props: RepoPickerProps): React.JSX.Element {
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: '4px', fontFamily: FONTS.heading, fontSize: '11px', letterSpacing: '0.15em', color: props.colors.textSecondary, textTransform: 'uppercase' }}>
      Repository
      <select
        value={props.value ? props.value.fullName : ''}
        onChange={e => {
          const match = props.repos.find(candidate => candidate.fullName === e.target.value);
          props.onChange(match ?? null);
        }}
        style={{ padding: '8px', borderRadius: '6px', border: `1px solid ${props.colors.border}`, background: props.colors.card, color: props.colors.text }}
      >
        <option value="">Pick a repository…</option>
        {props.repos.map(repo => (
          <option key={repo.fullName} value={repo.fullName}>
            {repo.fullName}
          </option>
        ))}
      </select>
    </label>
  );
}
